import * as Sentry from '@sentry/browser'
import { createBrowserHistory } from 'history'
import ReactGA from 'react-ga'
import posthog from 'posthog-js'

import { LOCALSTORAGE_TOKENS } from '../constants'
import { identify } from '../utils/identify'
import { JSONPARSER } from '../utils/logger'

export const history = createBrowserHistory()

history.listen(() => {
  const CRID = JSONPARSER(localStorage.getItem(LOCALSTORAGE_TOKENS.crid))
  const email = localStorage.getItem(LOCALSTORAGE_TOKENS.email)
  const UserId = localStorage.getItem(LOCALSTORAGE_TOKENS.userId)
  Sentry.setContext('User', {
    CRID,
    email,
    UserId
  })

  Sentry.setContext('Screen', {
    path: window.location.pathname
  })

  identify({
    CreditRequestId: CRID?.id,
    email,
    UserId,
    partnerSlug: localStorage.getItem(LOCALSTORAGE_TOKENS.partnerSlug) || ''
  })

  // eslint-disable-next-line import/no-named-as-default-member
  ReactGA.pageview(window.location.pathname + window.location.search)

  posthog.capture('$pageview')
})
